import { CircleCheckIcon, InfoIcon, LoaderCircleIcon, OctagonXIcon, TriangleAlertIcon } from 'lucide-react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

import { useTheme } from '@/_shared/hooks/useTheme';

const Toaster = ({ ...props }: ToasterProps) => {
  const { resolvedTheme } = useTheme();

  return (
    <Sonner
      theme={resolvedTheme}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <LoaderCircleIcon className="size-4 animate-spin" />,
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius-md)',
          '--info-bg': 'var(--popover)',
          '--info-border': 'var(--border)',
          '--info-text': 'var(--popover-foreground)',
          // Severity from the semantic triads (via the `--color-*` aliases — Sonner's own
          // `--success-bg`/`--success-border` var names collide with our triad tokens, so
          // referencing them directly would self-cycle). Triads flip in `.dark` automatically.
          '--success-bg': 'var(--color-success-bg)',
          '--success-border': 'var(--color-success-border)',
          '--success-text': 'var(--color-success)',
          '--warning-bg': 'var(--color-warning-bg)',
          '--warning-border': 'var(--color-warning-border)',
          '--warning-text': 'var(--color-warning)',
          '--error-bg': 'var(--color-danger-bg)',
          '--error-border': 'var(--color-danger-border)',
          '--error-text': 'var(--color-danger)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
